// extracted by mini-css-extract-plugin
export default {"ActionsHeader":"e5Lrmxwx","icon":"jp2YDvw8"};